<template>
  <div class="col-md-4">
    <div class="form-group">
      <label>{{label}}<span class="required">*</span>
		</label>
      <select class="form-control" :name="name"
                v-model="value[name]"
           
              v-validate="'required'">
        <option value="">Select</option>
        <option v-for="option in options" :key="option.key"
                :value="option.key">
          {{option.value}}
        </option>
      </select>
      <div v-show="errors.has(name)" class="help is-danger">{{required_message}}</div>
    </div>
  </div>
</template>
<script>
  export default {
  name: 'COMBO', inject: ['$validator'],
  props: ['options', 'name', 'label', 'value','required_message']
  }
</script>
